import { render, staticRenderFns } from "./DevAlarmList.vue?vue&type=template&id=79f5539d&"
import script from "./DevAlarmList.vue?vue&type=script&lang=js&"
export * from "./DevAlarmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports